import React from 'react'
import { array } from 'prop-types'
import intl from 'react-intl-universal'

import { branch } from 'baobab-react/higher-order'
import API, { axios } from 'utils/API'
import storage from 'utils/storage'
import { unionBy } from 'lodash'

import Tour from 'utils/monkey/reactour'
import csrfToken from 'utils/csrfToken'
import AccessToken from 'utils/AccessToken'
import { detectStopScroll } from 'utils/bodyScrollLock'

import Container from 'components/atoms/Container'
import OnboardingTooltip from 'components/molecules/OnboardingTooltip'
import Sticky from 'components/atoms/Sticky'
import InterestButton from 'components/molecules/InterestButton'
import Thumbnails from 'components/organisms/Thumbnails'

import StickyContent from '../StickyContent'
import TermsModal from '../TermsModal'

class RecommendationList extends React.Component {
  state = {
    isLoading: false,
    isLastPage: false,
    page: 1,
    isOpenTour: false,
    isOpenModal: true,
  }

  componentDidMount() {
    const type = 'recommendation-list'
    if (this.checkTour(type)) {
      const options = {
        headers: { 'X-CSRF-Token': csrfToken() },
      }
      API.post(API.endPoints({ type }).auth.onboarding_tooltip, {}, options).then(() => {
        this.setState({ isTourOpen: true })
      })
      detectStopScroll(this.disableBody)
    }
  }

  closeTour = () => {
    this.setState({ isTourOpen: false })
    document.body.style.overflow = ''
  }

  disableBody = () => {
    if (this.state.isTourOpen) {
      document.body.style.overflow = 'hidden'
    }
  }

  checkTour = (type) => {
    const { onboardingTooltip } = this.props
    return !!(onboardingTooltip && !onboardingTooltip.includes(type))
  }

  setIsLoading = (val) => {
    this.setState({ isLoading: val })
  }

  setIsLastPage = (val) => {
    this.setState({ isLastPage: val })
  }

  setPage = (val) => {
    this.setState({ page: val })
  }

  loadMoreSchools = () => {
    const schoolRecommendation = storage.select('serverProps', 'schoolRecommendation')
    const { page } = this.state
    this.setIsLoading(true)
    setTimeout(() => (
      axios({
        url: `/aptitude_test/recommendation/${storage.get('serverProps', 'reportId')}.json`,
        method: 'get',
        responseType: 'json',
        params: {
          page: page + 1,
        },
      }).then((response) => {
        const schools = response.data.schoolRecommendation
        schoolRecommendation.concat(schools)

        this.setIsLoading(false)
        this.setIsLastPage(response.data.isLastPage)
        this.setPage(parseInt(response.data.params.page, 10))
      })
    ), 500)
  }

  render() {
  const { interestedSchools, recommendedSchools, currentUser } = this.props
  const { isLoading, isLastPage, isOpenModal } = this.state
  const previouslyInterestedSchools = interestedSchools.map(school => ({
    ...school,
    interested: true,
    enabled: false,
  }))
  const allRecomendations = unionBy(previouslyInterestedSchools, recommendedSchools, 'id')
  const interestedSchoolsCount = allRecomendations.filter(school => school.interested).length
  const tourProps = {
    isOpen: this.state.isTourOpen,
    onRequestClose: this.closeTour,
    showNavigation: false,
    showNumber: false,
    showButtons: false,
    showCloseButton: false,
    showNavigationNumber: false,
    disableInteraction: true,
    disableKeyboardNavigation: true,
    rounded: 4,
    closeWithMask: false,
    steps: [
      {
        selector: '.interest-btn:enabled',
        content: ({ goTo }) => (
          <OnboardingTooltip
            text="Pastikan kamu memilih minimum 3 kampus yang telah direkomendasikan oleh Quipper Campus dengan menekan tombol “Saya Tertarik”"
            arrow="bottom"
            closeFunc={this.closeTour}
            nextFunc={() => goTo(1)}
          />
        ),
        style: {
          padding: '16px',
          boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.1)',
          top: '-2%',
        },
        position: 'top',
      },
      {
        selector: '.aptitude-recommendation__redirect-btn',
        content: ({ goTo }) => (
          <>
            <OnboardingTooltip
              text="Jika telah memilih Kampus rekomendasi, silakan tekan tombol Lihat Hasil Tes Minat Bakat kamu"
              arrow="bottom"
              backFunc={() => goTo(0)}
              completeFunc={this.closeTour}
            />
            <style jsx>
              {`
                :global(.onboarding-tooltip.bottom::after) {
                  left: 25% !important;

                  @media screen and (max-width: 767px) {
                    left: 75% !important;
                  }
                }
              `}
            </style>
          </>
        ),
        position: 'top',
        style: {
          padding: '16px',
          boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.1)',
          top: '-2%',
        },
      },
    ],
  }

  const updateTerms = (agree) => {
    const options = {
      headers: {
        'X-CSRF-Token': csrfToken(),
        authorization: `BEARER ${decodeURIComponent(AccessToken.get())}`,
      },
    }

    API.post('agreed_to_terms', { agree }, options).then((response) => {
      this.setState({ isOpenModal: false })
      storage.set(['serverProps', 'currentUser', 'agreed_to_aptitude_test_terms'], response.data.agreed_to_aptitude_test_terms)
    })
  }

  return (
    <div className="aptitude-recommended-campus">
      <Tour {...tourProps} />
      {currentUser.agreed_to_aptitude_test_terms === null && isOpenModal && (
        <TermsModal action={agree => updateTerms(agree)} />
      )}
      <Thumbnails
        kind="schools"
        data={allRecomendations}
        isLoading={isLoading}
        isLastPage={isLastPage}
        isLikeable={false}
        loadMoreText={intl.get('search.see_more_schools')}
        loadMoreFunction={this.loadMoreSchools}
        customFooterContent={InterestButton}
        openNewTab
      />
      <Sticky>
        <Container>
          <StickyContent num={interestedSchoolsCount} enabled={interestedSchoolsCount >= 3} />
        </Container>
      </Sticky>
      <style jsx>
        {`
          .aptitude-recommended-campus {
            :global(.campus-perfect-card__see-more) {
              display: none;
            }
            :global(.campus-perfect-card.disabled) {
              filter: grayscale(.8);
            }
          }
        `}
      </style>
    </div>
  )
  }
}

RecommendationList.propTypes = {
  recommendedSchools: array,
  interestedSchools: array,
  onboardingTooltip: array,
}

export { RecommendationList }

export default branch({
  currentUser: ['serverProps', 'currentUser'],
  recommendedSchools: ['serverProps', 'schoolRecommendation'],
  interestedSchools: ['serverProps', 'schoolInterest'],
  onboardingTooltip: ['serverProps', 'currentUser', 'tooltip'],
}, RecommendationList)
